__turbopack_context__.v({
  "hoverTarget": "LayerButton-module__O60YUW__hoverTarget",
  "hoverTrigger": "LayerButton-module__O60YUW__hoverTrigger",
});
